module.exports = __webpack_public_path__ + "static/media/eth.daf37478.svg";